export const code = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/
